export const PRIVACY_CONSENT_VERSION = 2;
export const PRIVACY_CONSENT_KEY = "lapstr:privacy-consent:v2";
export const PRIVACY_CONSENT_EVENT = "lapstr:privacy-consent-changed";

const DEFAULT_CONSENT = Object.freeze({
  version: PRIVACY_CONSENT_VERSION,
  analyticsEnabled: false,
  analyticsDecided: false,
  updatedAt: null,
  source: null,
});

function getCurrentUserId() {
  if (typeof window === "undefined") return "";
  try {
    const user = JSON.parse(window.localStorage.getItem("speedway_user") || "null");
    return String(user?.id || "");
  } catch {
    return "";
  }
}

function getConsentStorageKey(userId = getCurrentUserId()) {
  const normalizedUserId = String(userId || "").trim();
  return normalizedUserId ? `${PRIVACY_CONSENT_KEY}:${normalizedUserId}` : PRIVACY_CONSENT_KEY;
}

export function getPrivacyConsent(userId) {
  if (typeof window === "undefined") return { ...DEFAULT_CONSENT };
  try {
    const raw = window.localStorage.getItem(getConsentStorageKey(userId));
    if (!raw) return { ...DEFAULT_CONSENT };
    const parsed = JSON.parse(raw);
    if (Number(parsed?.version) !== PRIVACY_CONSENT_VERSION) return { ...DEFAULT_CONSENT };
    return {
      version: PRIVACY_CONSENT_VERSION,
      analyticsEnabled: parsed.analyticsEnabled === true,
      analyticsDecided: parsed.analyticsDecided === true,
      updatedAt: typeof parsed.updatedAt === "string" ? parsed.updatedAt : null,
      source: typeof parsed.source === "string" ? parsed.source : null,
    };
  } catch {
    return { ...DEFAULT_CONSENT };
  }
}

export function setAnalyticsConsent(enabled, source = null, userId) {
  if (typeof window === "undefined") return { ...DEFAULT_CONSENT };
  const next = {
    version: PRIVACY_CONSENT_VERSION,
    analyticsEnabled: enabled === true,
    analyticsDecided: true,
    updatedAt: new Date().toISOString(),
    source,
  };
  try {
    window.localStorage.setItem(getConsentStorageKey(userId), JSON.stringify(next));
    window.dispatchEvent(new CustomEvent(PRIVACY_CONSENT_EVENT, {
      detail: { ...next, userId: String(userId || getCurrentUserId() || "") },
    }));
  } catch {
    // The in-memory choice is still returned to the caller if storage is unavailable.
  }
  return next;
}

export function clearPrivacyConsent(userId) {
  if (typeof window === "undefined") return;
  const reviewConsent = {
    ...DEFAULT_CONSENT,
    source: "review",
    updatedAt: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(getConsentStorageKey(userId), JSON.stringify(reviewConsent));
    window.dispatchEvent(new CustomEvent(PRIVACY_CONSENT_EVENT, {
      detail: { ...reviewConsent, userId: String(userId || getCurrentUserId() || "") },
    }));
  } catch {
    // Ignore unavailable storage.
  }
}

export function hasAnalyticsConsent() {
  const consent = getPrivacyConsent();
  return consent.analyticsDecided && consent.analyticsEnabled;
}
